export default "__VITE_ASSET__bLNX6U6f8qE7L2W0pHPLmA__";